"use client"

import { useState, useEffect } from "react"
import { Bookmark, BookmarkCheck, Lightbulb, BrainCircuit } from "lucide-react"
import { Link, useLocation } from "react-router-dom"
import { MathJax } from "better-react-mathjax";

const MnemonicCard = ({ mnemonic }) => {
  const [isBookmarked, setIsBookmarked] = useState(false)

  // Get subject-specific styling
  const getSubjectStyles = () => {
    switch (mnemonic.subject.toLowerCase()) {
      case "physics":
        return {
          bgColor: "bg-blue-50",
          borderColor: "border-blue-200",
          textColor: "text-blue-600",
          iconBg: "bg-blue-100",
          iconColor: "text-blue-500",
        }
      case "chemistry":
        return {
          bgColor: "bg-green-50",
          borderColor: "border-green-200",
          textColor: "text-green-600",
          iconBg: "bg-green-100",
          iconColor: "text-green-500",
        }
      case "math":
        return {
          bgColor: "bg-orange-50",
          borderColor: "border-orange-200",
          textColor: "text-orange-600",
          iconBg: "bg-orange-100",
          iconColor: "text-orange-500",
        }
      default:
        return {
          bgColor: "bg-gray-50",
          borderColor: "border-gray-200",
          textColor: "text-gray-600",
          iconBg: "bg-gray-100",
          iconColor: "text-gray-500",
        }
    }
  }

  const styles = getSubjectStyles()

  // Check if mnemonic is bookmarked
  useEffect(() => {
    const bookmarks = JSON.parse(localStorage.getItem("bookmarks") || "[]")
    setIsBookmarked(bookmarks.some((bookmark) => bookmark.id === mnemonic.id))
  }, [mnemonic.id])

  // Toggle bookmark
  const toggleBookmark = () => {
    const bookmarks = JSON.parse(localStorage.getItem("bookmarks") || "[]")

    if (isBookmarked) {
      const updatedBookmarks = bookmarks.filter((bookmark) => bookmark.id !== mnemonic.id)
      localStorage.setItem("bookmarks", JSON.stringify(updatedBookmarks))
    } else {
      bookmarks.push(mnemonic)
      localStorage.setItem("bookmarks", JSON.stringify(bookmarks))
    }

    setIsBookmarked(!isBookmarked)
  }

  return (
    <div
      className={`rounded-lg border ${styles.borderColor} ${styles.bgColor} p-5 shadow-sm transition-all hover:shadow-md`}
    >
      <div className="flex justify-between items-start mb-3">
        <div className={`px-3 py-1 rounded-full text-sm font-medium ${styles.textColor} ${styles.iconBg}`}>
          {mnemonic.subject}
        </div>
        <button
          onClick={toggleBookmark}
          className="text-gray-400 hover:text-yellow-500 transition-colors"
          aria-label={isBookmarked ? "Remove bookmark" : "Add bookmark"}
        >
          {isBookmarked ? <BookmarkCheck className="w-5 h-5 text-yellow-500" /> : <Bookmark className="w-5 h-5" />}
        </button>
      </div>

<Link to={`/mnemonic/${mnemonic.id}`}>
  <div className="mnemonic-card">
    
      <h3 className="text-lg font-semibold mb-1">{mnemonic.chapter}</h3>
  </div>
</Link>
<Link to={`/mnemonic/${mnemonic.id}`}>
      <p className="text-gray-700 mb-3">{mnemonic.concept}</p>
</Link>

      <div className="flex items-center mb-4">
        <div className={`p-2 rounded-full ${styles.iconBg} mr-3`}>
          <Lightbulb className={`w-5 h-5 ${styles.iconColor}`} />
        </div>
<Link to={`/mnemonic/${mnemonic.id}`}>
        <p className="text-gray-800 font-medium">{mnemonic.mnemonic}</p>
</Link>
      </div>


    </div>
  )
}

export default MnemonicCard
